import type { ContentLang } from '../editorSlice'

/**
 * Потолок длины промпта картинки (контракт §5.2, дальше `422`). Константа
 * СВОЯ, а не `MAX_PROMPT_LENGTH` чата: совпадение значений случайно — это
 * лимит промпта генерации курса и лимит промпта картинки, два разных
 * контракта. Связать их одной константой значит уронить второй, меняя первый.
 */
export const IMAGE_PROMPT_MAX = 2000

export const clampPrompt = (value: string): string => value.slice(0, IMAGE_PROMPT_MAX)

/**
 * Локализованная пара промпта. Поля ОПЦИОНАЛЬНЫ: списочные ручки и ответы,
 * снятые до появления полей на бэке, их не несут. Именно из-за `undefined`
 * общий `getLocalizedField` тут неприменим — его дженерик требует
 * `Record<K | `${K}En`, string | null>`, а не `| undefined`.
 */
export interface PromptPair {
  imagePrompt?: string | null
  imagePromptEn?: string | null
}

export const promptKey = (lang: ContentLang): 'imagePrompt' | 'imagePromptEn' =>
  lang === 'ru' ? 'imagePrompt' : 'imagePromptEn'

/** Промпт слота ТЕКУЩЕГО языка. Фолбэка на второй язык нет намеренно: поле
 *  редактируемое, а подставленный чужой текст автор сохранил бы как свой. */
export const readPrompt = (obj: PromptPair, lang: ContentLang): string => obj[promptKey(lang)] ?? ''

/** Патч слота. Пустая строка — единственный способ очистить промпт (§5.2):
 *  `null` курс и урок игнорируют, а блок обнулил бы и соседние поля. */
export const writePrompt = (lang: ContentLang, value: string): PromptPair =>
  ({ [promptKey(lang)]: clampPrompt(value) }) as PromptPair

/** Поля промптов картинок скрыты (решение заказчика: пока путают авторов): баннер, маскоты,
 *  картинка урока, картиночные и составные блоки. Сами промпты в данных не трогаем. */
export const SHOW_IMAGE_PROMPTS = false
